import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=64113f48&scoped=true"
import script from "./departmentTree.vue?vue&type=script&lang=js"
export * from "./departmentTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64113f48",
  null
  
)

export default component.exports